import { Injectable, Type } from '@angular/core';

import { GiftTicketDownloadComponent } from '../components/gift-ticket-download.component';

import { DialogSizes, DialogMargins, DialogOptions, DialogPosition } from '@ui/dialog/dialog.service';
import { ModalEffects } from '@ui/dialog/store/modal.effects';

@Injectable()
export class GiftTicketDownloadEffects extends ModalEffects {
    protected modalId: string = 'gift-ticket-download';

    protected modalParams: [
        title: string,
        component: Type<GiftTicketDownloadComponent>,
        data?: any,
        size?: DialogSizes,
        margin?: DialogMargins,
        modalOptions?: Array<DialogOptions | DialogPosition>,
    ] = [
            'dev.myAccount.giftTicketDownload.title',
            GiftTicketDownloadComponent,
            {},
            DialogSizes.SIZE_M,
            DialogMargins.MARGIN_24,
        ];
}
